import React from 'react';
import { createPath } from '../../utils';
import { NODE_WIDTH, NODE_HEIGHT, NODE_PADDING, DefaultNodeConfig } from '../../constants';
export const TerminalNode = props => {
    const { size = { width: NODE_WIDTH, height: NODE_HEIGHT }, data = {} } = props;
    const { stroke = DefaultNodeConfig.stroke, label = DefaultNodeConfig.label, fill = DefaultNodeConfig.fill, fontFill = DefaultNodeConfig.fontFill, fontSize = DefaultNodeConfig.fontSize, } = data;
    const { width, height } = size;
    const rx = Math.min(height, width) / 2;
    const path = [
        ['M', rx, NODE_PADDING],
        ['L', width - rx, NODE_PADDING],
        ['C', width - 2 * NODE_PADDING, NODE_PADDING, width - 2 * NODE_PADDING, height / 2],
        ['', width - 2 * NODE_PADDING, height / 2],
        [
            'C',
            width - 2 * NODE_PADDING,
            height / 2,
            width - 2 * NODE_PADDING,
            height - 2 * NODE_PADDING,
        ],
        ['', width - rx, height - 2 * NODE_PADDING],
        ['L', rx, height - 2 * NODE_PADDING],
        ['C', NODE_PADDING, height - 2 * NODE_PADDING, NODE_PADDING, height / 2],
        ['', NODE_PADDING, height / 2],
        ['C', NODE_PADDING, height / 2, NODE_PADDING, NODE_PADDING],
        ['', rx, NODE_PADDING],
    ];
    return (React.createElement("svg", { viewBox: `0 0 ${width} ${height}`, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%" },
        React.createElement("path", { d: createPath(path), fill: fill, stroke: stroke }),
        React.createElement("text", { x: width / 2, y: height / 2, fill: fontFill, textAnchor: "middle", alignmentBaseline: "middle", fontSize: fontSize }, label),
        "Sorry, your browser does not support inline SVG."));
};
//# sourceMappingURL=index.js.map